import { ReactElement } from 'react';

import PhotoGalleryBlock from 'components/UI/PhotoGalleryBlock';
import PhotoGalleryCarousel from 'components/Contentful/PhotoGalleryCarousel';
import RichText from '../UI/Richtext';
import { MAX_SCREEN_WIDTH } from 'lib/consts';
import { Asset } from 'contentful';
import { IComponentDoctorGalleryByHubFields } from 'types/contentful';

export interface PhotoBlockProps {
  image: Asset;
  rowOneText?: string | undefined;
  rowTwoText?: string | undefined;
  rowThreeText?: string | undefined;
  link?: string | undefined;
  openInNewTab?: boolean | undefined;
}

export interface DoctorGalleryByHubProps extends IComponentDoctorGalleryByHubFields {
  gallery: PhotoBlockProps[];
}

export default function DoctorGalleryByHub({
  heading,
  copyAlignment,
  copy,
  gallery,
}: DoctorGalleryByHubProps): ReactElement {
  const imagesPerRow = 5;
  const maxImageWidth = Math.round(MAX_SCREEN_WIDTH / imagesPerRow);

  const alignmentClass =
    copyAlignment === 'left'
      ? 'text-left'
      : copyAlignment === 'right'
      ? 'text-right'
      : 'text-center';

  return (
    <div className="px-4 lg:px-16 xl:px-32 ecp-my">
      {heading && (
        <div className="text-center font-light text-new-34 md:text-4xl text-primary-actual">
          <RichText document={heading} />
        </div>
      )}
      {copy && (
        <RichText document={copy} classNames={`text-lg text-primary-actual ${alignmentClass}`} />
      )}
      {gallery.length > 5 ? (
        <div className="mt-4">
          <PhotoGalleryCarousel gallery={gallery} slidesToShow={imagesPerRow} />
        </div>
      ) : (
        <div className="flex flex-wrap mt-4">
          {gallery.map((image, i) => (
            <PhotoGalleryBlock
              key={i}
              {...image}
              width={imagesPerRow}
              query={`w=${maxImageWidth}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
